import { IoWarning } from "react-icons/io5";
import styles from "./notifications.module.css";

export const WarningToast = ({ message }: { message: string }) => (
  <div className={styles.warningToast}>
    <IoWarning className={styles.icon} />
    <span className={styles.message}>{message}</span>
  </div>
);
